import React, { useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { Box, CircularProgress, Divider, Tab, Tabs } from "@mui/material";

import { Comments, DrawerControl, Log } from "../../../shared/components";

import { useFetchArtefactsDetails } from "../mutation";
import { CreateArtefacts } from "./CreateArtefacts";
import { ArtefactUploadTab } from "./ArtefactUploadTab";
import { ArtefactReviewersTab } from "./ArtefactReviewersTab";
import { ArtefactAcceptTab } from "./ArtefactAcceptTab";

export const ArtefactsDetails = ({ projectId, artefactId, refetchArtefacts }: { projectId: string | undefined, artefactId: string | null, refetchArtefacts: () => void }) => {

    const { data: artefactDetails, isLoading: isPending, refetch } = useFetchArtefactsDetails(artefactId);
    const [currentTab, setCurrentTab] = useState('upload');
    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    const [editStatus, setEditStatus] = useState<{ status: boolean; id: string | null, projectId: string | null }>({
        status: false,
        id: null,
        projectId: null
    });

    if (isPending) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box height={'100%'} display={'flex'} flexDirection={'column'}>
            <TabContext value={currentTab}>
                <Box display="flex" alignItems="center" alignContent="center">
                    <Tabs
                        value={currentTab}
                        onChange={handleChangeTab}
                        aria-label="Tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{ minHeight: "auto" }}
                    >
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'Upload'}
                            value={'upload'}
                        />
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'Reviewers'}
                            value={'reviewers'}
                        />
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'Accept'}
                            value={'accept'}
                        />
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'comments'}
                            value={'comments'}
                        />
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'log'}
                            value={'log'}
                        />
                    </Tabs>
                </Box>
                <Divider />
                <Box flex={1} overflow="hidden">
                    <TabPanel value="upload" sx={{ p: 2, height: "100%" }}>
                        <ArtefactUploadTab
                            artefactId={artefactId}
                            artefactDetails={artefactDetails}
                            refetch={refetch}
                            refetchArtefacts={refetchArtefacts}
                        />
                    </TabPanel>
                    <TabPanel value="reviewers" sx={{ p: 2, height: "100%" }}>
                        <ArtefactReviewersTab
                            artefactId={artefactId}
                            artefactDetails={artefactDetails}
                            projectId={projectId}
                        />
                    </TabPanel>
                    <TabPanel value="accept" sx={{ p: 2, height: "100%" }}>
                        <ArtefactAcceptTab
                            artefactId={artefactId}
                            artefactDetails={artefactDetails}
                            refetch={refetch}
                            refetchArtefacts={refetchArtefacts}
                            onEditArtefact={() => setEditStatus({ status: true, id: String(artefactDetails?.id), projectId: String(artefactDetails?.project_id) })}
                        />
                    </TabPanel>
                    <TabPanel value="comments" sx={{ p: 2, height: "100%" }}>
                        <Comments topic={["PROJECT_ARTEFACT"]} sub_event={['ARTEFACT_COMMENT_ADDED']} object_id={String(artefactDetails?.id)} parent_id={""} />
                    </TabPanel>
                    <TabPanel value="log" sx={{ pl: 2, py: 2, pr: 0, height: "100%" }}>
                        <Log topic={["ARTEFACT"]} sub_event={[]} object_id={artefactDetails?.id} parent_id={""} />
                    </TabPanel>
                </Box>
            </TabContext>
            <DrawerControl
                title={editStatus.status ? "Edit Artefact Requirement" : "Create Artefact Requirement"}
                subTitle={""}
                isOpen={editStatus.status}
                handleClose={() => setEditStatus({ status: false, id: null, projectId: null })}
                children={
                    <CreateArtefacts
                        projectId={String(editStatus.projectId)}
                        stageGateId={null}
                        isEdit={editStatus.status}
                        artefactId={editStatus.id}
                        onClose={() => setEditStatus({ status: false, id: null, projectId: null })}
                        onSave={() => {
                            setEditStatus({ status: false, id: null, projectId: null });
                            refetchArtefacts();
                        }}
                    />
                }
            />
        </Box>
    );
};
